define(
    'FacetItemsInfo3.View'
    , [
        'SCView',
        'facetitemsinfo3.tpl'
    ]
    , function (
        SCViewModule,
        facetItemsInfo3_tpl
    ) {
    
    'use strict';

    var SCView = SCViewModule.SCView;

    var thirdFacetItemField = '';

    function FacetItemsInfo3View(options) {

        SCView.call(this, options);
        this.template = facetItemsInfo3_tpl;
        this.contextDataRequest = ['item'];
        this.config = options.Data;

    }

    FacetItemsInfo3View.prototype = Object.create(SCView.prototype);
    FacetItemsInfo3View.prototype.constructor = FacetItemsInfo3View;

    FacetItemsInfo3View.prototype.getContext = function () {

        var itemField = this.config.itemfieldsThree;
        thirdFacetItemField = this.contextData.item()[itemField];

        return {

            source: thirdFacetItemField
        };
    }

    return FacetItemsInfo3View;
});
